/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddOrUpdateEmailRequest,
  CreateExternalApiUserRequest,
  CreateExternalApiUserResponse,
  CreateUser,
  CreateUserResponse,
  CreateUserResult,
  GetCreateUsersParams,
  GetPaginatedSimpleUsersWithPersonNameForAdminParams,
  GetPaginatedSimpleUsersWithPersonNameParams,
  GetPaginatedUserDataParams,
  GetSimpleUsersWithNamesParams,
  GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams,
  GetUserGroupsParams,
  GetUserLicensesParams,
  GetUserParams,
  SimpleLicense,
  SimpleUser,
  SimpleUserPagination,
  SimpleUserWithPersonAndEmailInfo,
  UpdateApiKeyRequest,
  UpdateApiKeyResponse,
  UpdateGroupMembershipsRequest,
  UpdateUser,
  UserDto,
  UserDtoPaginatedData
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetCreateUsersUrl = (params?: GetCreateUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["personIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetCreateUsers?${stringifiedParams}` : `/api/User/GetCreateUsers`
}

export const getCreateUsers = async (params?: GetCreateUsersParams, options?: RequestInit): Promise<CreateUser[]> => {
  
  return customInstance<CreateUser[]>(getGetCreateUsersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetCreateUsersQueryKey = (params?: GetCreateUsersParams,) => {
    return [
    `/api/User/GetCreateUsers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCreateUsersQueryOptions = <TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(params?: GetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreateUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreateUsers>>> = ({ signal }) => getCreateUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCreateUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getCreateUsers>>>
export type GetCreateUsersQueryError = ErrorType<unknown>


export function useGetCreateUsers<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCreateUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreateUsers>>,
          TError,
          Awaited<ReturnType<typeof getCreateUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCreateUsers<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCreateUsers>>,
          TError,
          Awaited<ReturnType<typeof getCreateUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCreateUsers<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCreateUsers<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCreateUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCreateUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(params?: GetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreateUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreateUsers>>> = ({ signal }) => getCreateUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCreateUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCreateUsers>>>
export type GetCreateUsersSuspenseQueryError = ErrorType<unknown>


export function useGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCreateUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCreateUsersSuspense<TData = Awaited<ReturnType<typeof getCreateUsers>>, TError = ErrorType<unknown>>(
 params?: GetCreateUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCreateUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCreateUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserCreateUrl = () => {


  

  return `/api/User/Create`
}

export const userCreate = async (createUser: CreateUser, options?: RequestInit): Promise<CreateUserResponse> => {
  
  return customInstance<CreateUserResponse>(getUserCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUser,)
  }
);}




export const getUserCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,{data: BodyType<CreateUser>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,{data: BodyType<CreateUser>}, TContext> => {

const mutationKey = ['userCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userCreate>>, {data: BodyType<CreateUser>}> = (props) => {
          const {data} = props ?? {};

          return  userCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UserCreateMutationResult = NonNullable<Awaited<ReturnType<typeof userCreate>>>
    export type UserCreateMutationBody = BodyType<CreateUser>
    export type UserCreateMutationError = ErrorType<unknown>

    export const useUserCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userCreate>>, TError,{data: BodyType<CreateUser>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof userCreate>>,
        TError,
        {data: BodyType<CreateUser>},
        TContext
      > => {

      const mutationOptions = getUserCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getCreateUsersUrl = () => {


  

  return `/api/User/CreateUsers`
}

export const createUsers = async (createUser: CreateUser[], options?: RequestInit): Promise<CreateUserResult[]> => {
  
  return customInstance<CreateUserResult[]>(getCreateUsersUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUser,)
  }
);}




export const getCreateUsersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUsers>>, TError,{data: BodyType<CreateUser[]>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUsers>>, TError,{data: BodyType<CreateUser[]>}, TContext> => {

const mutationKey = ['createUsers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUsers>>, {data: BodyType<CreateUser[]>}> = (props) => {
          const {data} = props ?? {};

          return  createUsers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUsersMutationResult = NonNullable<Awaited<ReturnType<typeof createUsers>>>
    export type CreateUsersMutationBody = BodyType<CreateUser[]>
    export type CreateUsersMutationError = ErrorType<unknown>

    export const useCreateUsers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUsers>>, TError,{data: BodyType<CreateUser[]>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUsers>>,
        TError,
        {data: BodyType<CreateUser[]>},
        TContext
      > => {

      const mutationOptions = getCreateUsersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getUpdateGroupMembershipsUrl = () => {


  

  return `/api/User/UpdateGroupMemberships`
}

export const updateGroupMemberships = async (updateGroupMembershipsRequest: UpdateGroupMembershipsRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUpdateGroupMembershipsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateGroupMembershipsRequest,)
  }
);}




export const getUpdateGroupMembershipsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroupMemberships>>, TError,{data: BodyType<UpdateGroupMembershipsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGroupMemberships>>, TError,{data: BodyType<UpdateGroupMembershipsRequest>}, TContext> => {

const mutationKey = ['updateGroupMemberships'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGroupMemberships>>, {data: BodyType<UpdateGroupMembershipsRequest>}> = (props) => {
          const {data} = props ?? {};

          return  updateGroupMemberships(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGroupMembershipsMutationResult = NonNullable<Awaited<ReturnType<typeof updateGroupMemberships>>>
    export type UpdateGroupMembershipsMutationBody = BodyType<UpdateGroupMembershipsRequest>
    export type UpdateGroupMembershipsMutationError = ErrorType<unknown>

    export const useUpdateGroupMemberships = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroupMemberships>>, TError,{data: BodyType<UpdateGroupMembershipsRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGroupMemberships>>,
        TError,
        {data: BodyType<UpdateGroupMembershipsRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateGroupMembershipsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetPaginatedUserDataUrl = (params?: GetPaginatedUserDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["includeUserIds","excludeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetPaginatedUserData?${stringifiedParams}` : `/api/User/GetPaginatedUserData`
}

export const getPaginatedUserData = async (params?: GetPaginatedUserDataParams, options?: RequestInit): Promise<UserDtoPaginatedData> => {
  
  return customInstance<UserDtoPaginatedData>(getGetPaginatedUserDataUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPaginatedUserDataQueryKey = (params?: GetPaginatedUserDataParams,) => {
    return [
    `/api/User/GetPaginatedUserData`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaginatedUserDataQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(params?: GetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedUserDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedUserData>>> = ({ signal }) => getPaginatedUserData(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaginatedUserDataQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedUserData>>>
export type GetPaginatedUserDataQueryError = ErrorType<unknown>


export function useGetPaginatedUserData<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPaginatedUserDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedUserData>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedUserData<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedUserData>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedUserData<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPaginatedUserData<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaginatedUserDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPaginatedUserDataSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(params?: GetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedUserDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedUserData>>> = ({ signal }) => getPaginatedUserData(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaginatedUserDataSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedUserData>>>
export type GetPaginatedUserDataSuspenseQueryError = ErrorType<unknown>


export function useGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPaginatedUserDataParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPaginatedUserDataSuspense<TData = Awaited<ReturnType<typeof getPaginatedUserData>>, TError = ErrorType<unknown>>(
 params?: GetPaginatedUserDataParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedUserData>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaginatedUserDataSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetUserUrl = (params?: GetUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUser?${stringifiedParams}` : `/api/User/GetUser`
}

export const getUser = async (params?: GetUserParams, options?: RequestInit): Promise<UserDto> => {
  
  return customInstance<UserDto>(getGetUserUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUserQueryKey = (params?: GetUserParams,) => {
    return [
    `/api/User/GetUser`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = ErrorType<unknown>


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(params?: GetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserSuspenseQueryError = ErrorType<unknown>


export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUserSuspense<TData = Awaited<ReturnType<typeof getUser>>, TError = ErrorType<unknown>>(
 params?: GetUserParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSimpleUsersWithPersonAndEmailInfoForAbsenceUrl = (params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["includeUserIds","excludeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetSimpleUsersWithPersonAndEmailInfoForAbsence?${stringifiedParams}` : `/api/User/GetSimpleUsersWithPersonAndEmailInfoForAbsence`
}

export const getSimpleUsersWithPersonAndEmailInfoForAbsence = async (params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: RequestInit): Promise<SimpleUserWithPersonAndEmailInfo[]> => {
  
  return customInstance<SimpleUserWithPersonAndEmailInfo[]>(getGetSimpleUsersWithPersonAndEmailInfoForAbsenceUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryKey = (params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams,) => {
    return [
    `/api/User/GetSimpleUsersWithPersonAndEmailInfoForAbsence`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>> = ({ signal }) => getSimpleUsersWithPersonAndEmailInfoForAbsence(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>>
export type GetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryError = ErrorType<unknown>


export function useGetSimpleUsersWithPersonAndEmailInfoForAbsence<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersWithPersonAndEmailInfoForAbsence<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersWithPersonAndEmailInfoForAbsence<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleUsersWithPersonAndEmailInfoForAbsence<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersWithPersonAndEmailInfoForAbsenceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>> = ({ signal }) => getSimpleUsersWithPersonAndEmailInfoForAbsence(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>>
export type GetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithPersonAndEmailInfoForAbsenceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithPersonAndEmailInfoForAbsence>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleUsersWithPersonAndEmailInfoForAbsenceSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPaginatedSimpleUsersWithPersonNameUrl = (params: GetPaginatedSimpleUsersWithPersonNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["excludeUserIds","includeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetPaginatedSimpleUsersWithPersonName?${stringifiedParams}` : `/api/User/GetPaginatedSimpleUsersWithPersonName`
}

export const getPaginatedSimpleUsersWithPersonName = async (params: GetPaginatedSimpleUsersWithPersonNameParams, options?: RequestInit): Promise<SimpleUserPagination> => {
  
  return customInstance<SimpleUserPagination>(getGetPaginatedSimpleUsersWithPersonNameUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPaginatedSimpleUsersWithPersonNameQueryKey = (params?: GetPaginatedSimpleUsersWithPersonNameParams,) => {
    return [
    `/api/User/GetPaginatedSimpleUsersWithPersonName`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaginatedSimpleUsersWithPersonNameQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedSimpleUsersWithPersonNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>> = ({ signal }) => getPaginatedSimpleUsersWithPersonName(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaginatedSimpleUsersWithPersonNameQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>>
export type GetPaginatedSimpleUsersWithPersonNameQueryError = ErrorType<unknown>


export function useGetPaginatedSimpleUsersWithPersonName<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedSimpleUsersWithPersonName<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedSimpleUsersWithPersonName<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPaginatedSimpleUsersWithPersonName<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaginatedSimpleUsersWithPersonNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPaginatedSimpleUsersWithPersonNameSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedSimpleUsersWithPersonNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>> = ({ signal }) => getPaginatedSimpleUsersWithPersonName(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaginatedSimpleUsersWithPersonNameSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>>
export type GetPaginatedSimpleUsersWithPersonNameSuspenseQueryError = ErrorType<unknown>


export function useGetPaginatedSimpleUsersWithPersonNameSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedSimpleUsersWithPersonNameSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedSimpleUsersWithPersonNameSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPaginatedSimpleUsersWithPersonNameSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaginatedSimpleUsersWithPersonNameSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPaginatedSimpleUsersWithPersonNameForAdminUrl = (params: GetPaginatedSimpleUsersWithPersonNameForAdminParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["excludeUserIds","includeUserIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetPaginatedSimpleUsersWithPersonNameForAdmin?${stringifiedParams}` : `/api/User/GetPaginatedSimpleUsersWithPersonNameForAdmin`
}

export const getPaginatedSimpleUsersWithPersonNameForAdmin = async (params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: RequestInit): Promise<SimpleUserPagination> => {
  
  return customInstance<SimpleUserPagination>(getGetPaginatedSimpleUsersWithPersonNameForAdminUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPaginatedSimpleUsersWithPersonNameForAdminQueryKey = (params?: GetPaginatedSimpleUsersWithPersonNameForAdminParams,) => {
    return [
    `/api/User/GetPaginatedSimpleUsersWithPersonNameForAdmin`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaginatedSimpleUsersWithPersonNameForAdminQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedSimpleUsersWithPersonNameForAdminQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>> = ({ signal }) => getPaginatedSimpleUsersWithPersonNameForAdmin(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaginatedSimpleUsersWithPersonNameForAdminQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>>
export type GetPaginatedSimpleUsersWithPersonNameForAdminQueryError = ErrorType<unknown>


export function useGetPaginatedSimpleUsersWithPersonNameForAdmin<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedSimpleUsersWithPersonNameForAdmin<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>,
          TError,
          Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedSimpleUsersWithPersonNameForAdmin<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPaginatedSimpleUsersWithPersonNameForAdmin<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaginatedSimpleUsersWithPersonNameForAdminQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPaginatedSimpleUsersWithPersonNameForAdminSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaginatedSimpleUsersWithPersonNameForAdminQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>> = ({ signal }) => getPaginatedSimpleUsersWithPersonNameForAdmin(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPaginatedSimpleUsersWithPersonNameForAdminSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>>
export type GetPaginatedSimpleUsersWithPersonNameForAdminSuspenseQueryError = ErrorType<unknown>


export function useGetPaginatedSimpleUsersWithPersonNameForAdminSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedSimpleUsersWithPersonNameForAdminSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPaginatedSimpleUsersWithPersonNameForAdminSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPaginatedSimpleUsersWithPersonNameForAdminSuspense<TData = Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError = ErrorType<unknown>>(
 params: GetPaginatedSimpleUsersWithPersonNameForAdminParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPaginatedSimpleUsersWithPersonNameForAdmin>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPaginatedSimpleUsersWithPersonNameForAdminSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSimpleUsersWithNamesUrl = (params?: GetSimpleUsersWithNamesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["userIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetSimpleUsersWithNames?${stringifiedParams}` : `/api/User/GetSimpleUsersWithNames`
}

export const getSimpleUsersWithNames = async (params?: GetSimpleUsersWithNamesParams, options?: RequestInit): Promise<SimpleUser[]> => {
  
  return customInstance<SimpleUser[]>(getGetSimpleUsersWithNamesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetSimpleUsersWithNamesQueryKey = (params?: GetSimpleUsersWithNamesParams,) => {
    return [
    `/api/User/GetSimpleUsersWithNames`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSimpleUsersWithNamesQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersWithNamesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersWithNames>>> = ({ signal }) => getSimpleUsersWithNames(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleUsersWithNamesQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersWithNames>>>
export type GetSimpleUsersWithNamesQueryError = ErrorType<unknown>


export function useGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUsersWithNamesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersWithNames>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersWithNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleUsersWithNames>>,
          TError,
          Awaited<ReturnType<typeof getSimpleUsersWithNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleUsersWithNames<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleUsersWithNamesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetSimpleUsersWithNamesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleUsersWithNamesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleUsersWithNames>>> = ({ signal }) => getSimpleUsersWithNames(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSimpleUsersWithNamesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleUsersWithNames>>>
export type GetSimpleUsersWithNamesSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimpleUsersWithNamesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetSimpleUsersWithNamesSuspense<TData = Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError = ErrorType<unknown>>(
 params?: GetSimpleUsersWithNamesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleUsersWithNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSimpleUsersWithNamesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUpdateUserUrl = () => {


  

  return `/api/User/UpdateUser`
}

export const updateUser = async (updateUser: UpdateUser, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getUpdateUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUser,)
  }
);}




export const getUpdateUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{data: BodyType<UpdateUser>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{data: BodyType<UpdateUser>}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {data: BodyType<UpdateUser>}> = (props) => {
          const {data} = props ?? {};

          return  updateUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = BodyType<UpdateUser>
    export type UpdateUserMutationError = ErrorType<unknown>

    export const useUpdateUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{data: BodyType<UpdateUser>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {data: BodyType<UpdateUser>},
        TContext
      > => {

      const mutationOptions = getUpdateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetUserGroupsUrl = (params?: GetUserGroupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUserGroups?${stringifiedParams}` : `/api/User/GetUserGroups`
}

export const getUserGroups = async (params?: GetUserGroupsParams, options?: RequestInit): Promise<SimpleUser[]> => {
  
  return customInstance<SimpleUser[]>(getGetUserGroupsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUserGroupsQueryKey = (params?: GetUserGroupsParams,) => {
    return [
    `/api/User/GetUserGroups`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUserGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(params?: GetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGroups>>> = ({ signal }) => getUserGroups(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGroups>>>
export type GetUserGroupsQueryError = ErrorType<unknown>


export function useGetUserGroups<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGroups>>,
          TError,
          Awaited<ReturnType<typeof getUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserGroups<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGroups>>,
          TError,
          Awaited<ReturnType<typeof getUserGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserGroups<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUserGroups<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetUserGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(params?: GetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGroups>>> = ({ signal }) => getUserGroups(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGroups>>>
export type GetUserGroupsSuspenseQueryError = ErrorType<unknown>


export function useGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserGroupsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUserGroupsSuspense<TData = Awaited<ReturnType<typeof getUserGroups>>, TError = ErrorType<unknown>>(
 params?: GetUserGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserGroupsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMyLicensesUrl = () => {


  

  return `/api/User/GetMyLicenses`
}

export const getMyLicenses = async ( options?: RequestInit): Promise<SimpleLicense[]> => {
  
  return customInstance<SimpleLicense[]>(getGetMyLicensesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMyLicensesQueryKey = () => {
    return [
    `/api/User/GetMyLicenses`
    ] as const;
    }

    
export const getGetMyLicensesQueryOptions = <TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyLicensesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyLicenses>>> = ({ signal }) => getMyLicenses({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyLicenses>>>
export type GetMyLicensesQueryError = ErrorType<unknown>


export function useGetMyLicenses<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyLicenses>>,
          TError,
          Awaited<ReturnType<typeof getMyLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyLicenses<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyLicenses>>,
          TError,
          Awaited<ReturnType<typeof getMyLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyLicenses<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMyLicenses<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyLicensesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMyLicensesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyLicensesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyLicenses>>> = ({ signal }) => getMyLicenses({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyLicensesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyLicenses>>>
export type GetMyLicensesSuspenseQueryError = ErrorType<unknown>


export function useGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetMyLicensesSuspense<TData = Awaited<ReturnType<typeof getMyLicenses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyLicensesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetUserLicensesUrl = (params?: GetUserLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/User/GetUserLicenses?${stringifiedParams}` : `/api/User/GetUserLicenses`
}

export const getUserLicenses = async (params?: GetUserLicensesParams, options?: RequestInit): Promise<SimpleLicense[]> => {
  
  return customInstance<SimpleLicense[]>(getGetUserLicensesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUserLicensesQueryKey = (params?: GetUserLicensesParams,) => {
    return [
    `/api/User/GetUserLicenses`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUserLicensesQueryOptions = <TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(params?: GetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLicensesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserLicenses>>> = ({ signal }) => getUserLicenses(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserLicenses>>>
export type GetUserLicensesQueryError = ErrorType<unknown>


export function useGetUserLicenses<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserLicensesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLicenses>>,
          TError,
          Awaited<ReturnType<typeof getUserLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserLicenses<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserLicenses>>,
          TError,
          Awaited<ReturnType<typeof getUserLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserLicenses<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUserLicenses<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserLicensesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetUserLicensesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(params?: GetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLicensesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserLicenses>>> = ({ signal }) => getUserLicenses(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserLicensesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUserLicenses>>>
export type GetUserLicensesSuspenseQueryError = ErrorType<unknown>


export function useGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUserLicensesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetUserLicensesSuspense<TData = Awaited<ReturnType<typeof getUserLicenses>>, TError = ErrorType<unknown>>(
 params?: GetUserLicensesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUserLicenses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserLicensesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAuthenticatedUserUrl = () => {


  

  return `/api/User/GetAuthenticatedUser`
}

export const getAuthenticatedUser = async ( options?: RequestInit): Promise<UserDto> => {
  
  return customInstance<UserDto>(getGetAuthenticatedUserUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAuthenticatedUserQueryKey = () => {
    return [
    `/api/User/GetAuthenticatedUser`
    ] as const;
    }

    
export const getGetAuthenticatedUserQueryOptions = <TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthenticatedUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthenticatedUser>>> = ({ signal }) => getAuthenticatedUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAuthenticatedUserQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthenticatedUser>>>
export type GetAuthenticatedUserQueryError = ErrorType<unknown>


export function useGetAuthenticatedUser<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthenticatedUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthenticatedUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAuthenticatedUser<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthenticatedUser>>,
          TError,
          Awaited<ReturnType<typeof getAuthenticatedUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAuthenticatedUser<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAuthenticatedUser<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAuthenticatedUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAuthenticatedUserSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthenticatedUserQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthenticatedUser>>> = ({ signal }) => getAuthenticatedUser({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAuthenticatedUserSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthenticatedUser>>>
export type GetAuthenticatedUserSuspenseQueryError = ErrorType<unknown>


export function useGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAuthenticatedUserSuspense<TData = Awaited<ReturnType<typeof getAuthenticatedUser>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthenticatedUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAuthenticatedUserSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCreateExternalServiceUserUrl = () => {


  

  return `/api/User/CreateExternalServiceUser`
}

export const createExternalServiceUser = async (createExternalApiUserRequest: CreateExternalApiUserRequest, options?: RequestInit): Promise<CreateExternalApiUserResponse> => {
  
  return customInstance<CreateExternalApiUserResponse>(getCreateExternalServiceUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createExternalApiUserRequest,)
  }
);}




export const getCreateExternalServiceUserMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalServiceUser>>, TError,{data: BodyType<CreateExternalApiUserRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createExternalServiceUser>>, TError,{data: BodyType<CreateExternalApiUserRequest>}, TContext> => {

const mutationKey = ['createExternalServiceUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createExternalServiceUser>>, {data: BodyType<CreateExternalApiUserRequest>}> = (props) => {
          const {data} = props ?? {};

          return  createExternalServiceUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateExternalServiceUserMutationResult = NonNullable<Awaited<ReturnType<typeof createExternalServiceUser>>>
    export type CreateExternalServiceUserMutationBody = BodyType<CreateExternalApiUserRequest>
    export type CreateExternalServiceUserMutationError = ErrorType<unknown>

    export const useCreateExternalServiceUser = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createExternalServiceUser>>, TError,{data: BodyType<CreateExternalApiUserRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createExternalServiceUser>>,
        TError,
        {data: BodyType<CreateExternalApiUserRequest>},
        TContext
      > => {

      const mutationOptions = getCreateExternalServiceUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetDatabaseRulesUrl = () => {


  

  return `/api/User/GetDatabaseRules`
}

export const getDatabaseRules = async ( options?: RequestInit): Promise<string[]> => {
  
  return customInstance<string[]>(getGetDatabaseRulesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetDatabaseRulesQueryKey = () => {
    return [
    `/api/User/GetDatabaseRules`
    ] as const;
    }

    
export const getGetDatabaseRulesQueryOptions = <TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatabaseRulesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatabaseRules>>> = ({ signal }) => getDatabaseRules({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDatabaseRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getDatabaseRules>>>
export type GetDatabaseRulesQueryError = ErrorType<unknown>


export function useGetDatabaseRules<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseRules>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDatabaseRules<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDatabaseRules>>,
          TError,
          Awaited<ReturnType<typeof getDatabaseRules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDatabaseRules<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDatabaseRules<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDatabaseRulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetDatabaseRulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDatabaseRulesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDatabaseRules>>> = ({ signal }) => getDatabaseRules({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDatabaseRulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDatabaseRules>>>
export type GetDatabaseRulesSuspenseQueryError = ErrorType<unknown>


export function useGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDatabaseRulesSuspense<TData = Awaited<ReturnType<typeof getDatabaseRules>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDatabaseRules>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDatabaseRulesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUpdateApiKeyUrl = () => {


  

  return `/api/User/UpdateApiKey`
}

export const updateApiKey = async (updateApiKeyRequest: UpdateApiKeyRequest, options?: RequestInit): Promise<UpdateApiKeyResponse> => {
  
  return customInstance<UpdateApiKeyResponse>(getUpdateApiKeyUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateApiKeyRequest,)
  }
);}




export const getUpdateApiKeyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApiKey>>, TError,{data: BodyType<UpdateApiKeyRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateApiKey>>, TError,{data: BodyType<UpdateApiKeyRequest>}, TContext> => {

const mutationKey = ['updateApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateApiKey>>, {data: BodyType<UpdateApiKeyRequest>}> = (props) => {
          const {data} = props ?? {};

          return  updateApiKey(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof updateApiKey>>>
    export type UpdateApiKeyMutationBody = BodyType<UpdateApiKeyRequest>
    export type UpdateApiKeyMutationError = ErrorType<unknown>

    export const useUpdateApiKey = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateApiKey>>, TError,{data: BodyType<UpdateApiKeyRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateApiKey>>,
        TError,
        {data: BodyType<UpdateApiKeyRequest>},
        TContext
      > => {

      const mutationOptions = getUpdateApiKeyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getAddOrUpdateEmailUrl = () => {


  

  return `/api/User/AddOrUpdateEmail`
}

export const addOrUpdateEmail = async (addOrUpdateEmailRequest: AddOrUpdateEmailRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getAddOrUpdateEmailUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addOrUpdateEmailRequest,)
  }
);}




export const getAddOrUpdateEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateEmail>>, TError,{data: BodyType<AddOrUpdateEmailRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateEmail>>, TError,{data: BodyType<AddOrUpdateEmailRequest>}, TContext> => {

const mutationKey = ['addOrUpdateEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addOrUpdateEmail>>, {data: BodyType<AddOrUpdateEmailRequest>}> = (props) => {
          const {data} = props ?? {};

          return  addOrUpdateEmail(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddOrUpdateEmailMutationResult = NonNullable<Awaited<ReturnType<typeof addOrUpdateEmail>>>
    export type AddOrUpdateEmailMutationBody = BodyType<AddOrUpdateEmailRequest>
    export type AddOrUpdateEmailMutationError = ErrorType<unknown>

    export const useAddOrUpdateEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addOrUpdateEmail>>, TError,{data: BodyType<AddOrUpdateEmailRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addOrUpdateEmail>>,
        TError,
        {data: BodyType<AddOrUpdateEmailRequest>},
        TContext
      > => {

      const mutationOptions = getAddOrUpdateEmailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    